var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-219.000000, -1086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4193548,39.516129 L1.61290323,39.516129 C0.722580645,39.516129 0,38.7935484 0,37.9032258 L0,1.61290323 C0,0.722580645 0.722580645,0 1.61290323,0 L48.3870968,0 C49.2774194,0 50,0.722580645 50,1.61290323 L50,35.483871",
    id: "Stroke-1",
    stroke: "#A17D58",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.87096774 L50,8.87096774",
    id: "Stroke-3",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4516129,4.43548387 C6.4516129,5.10322581 5.91048387,5.64516129 5.24193548,5.64516129 C4.5733871,5.64516129 4.03225806,5.10322581 4.03225806,4.43548387 C4.03225806,3.76774194 4.5733871,3.22580645 5.24193548,3.22580645 C5.91048387,3.22580645 6.4516129,3.76774194 6.4516129,4.43548387",
    id: "Fill-5",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2903226,4.43548387 C11.2903226,5.10322581 10.7491935,5.64516129 10.0806452,5.64516129 C9.41209677,5.64516129 8.87096774,5.10322581 8.87096774,4.43548387 C8.87096774,3.76774194 9.41209677,3.22580645 10.0806452,3.22580645 C10.7491935,3.22580645 11.2903226,3.76774194 11.2903226,4.43548387",
    id: "Fill-7",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1290323,4.43548387 C16.1290323,5.10322581 15.5879032,5.64516129 14.9193548,5.64516129 C14.2508065,5.64516129 13.7096774,5.10322581 13.7096774,4.43548387 C13.7096774,3.76774194 14.2508065,3.22580645 14.9193548,3.22580645 C15.5879032,3.22580645 16.1290323,3.76774194 16.1290323,4.43548387",
    id: "Fill-9",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67741935,17.7419355 L40.3225806,17.7419355",
    id: "Stroke-11",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67741935,23.3870968 L23.3870968,23.3870968",
    id: "Stroke-13",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4193548,23.3870968 L29.4991935,30.3459677 L44.4475806,48.8298387 C45.5387097,50.1935484 47.5362903,50.3951613 48.8782258,49.2774194 C50.2008065,48.175 50.3798387,46.208871 49.2774194,44.8862903 L34.3379032,27.1201613 L27.4193548,23.3870968 Z",
    id: "Stroke-15",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7419355,45.9677419 L44.3548387,44.3548387",
    id: "Stroke-17",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon9);
export default __webpack_public_path__ + "static/media/product-icon9.358f30c53b3da25bc53c3089acf58aa8.svg";
export { ForwardRef as ReactComponent };